/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { components } from 'react-select';

import { Typo } from 'uikit/content';

import styles from '../styles/selectOption.module.scss';

export const SelectOptionContent = ({ name, body, color }) => (
  <div className={styles.element}>
    <div className={styles.dot} style={{ backgroundColor: color }} />
    <div className={styles.content}>
      <Typo
        className={styles.title}
        variant="s02"
        weight="medium"
      >
        {name}
      </Typo>
      <div className={styles.body}>
        {body?.map((item) => (
          <Typo
            className={styles.item}
            variant="s01"
            key={item}
          >
            {item}
          </Typo>
        ))}
      </div>
    </div>
  </div>
);

SelectOptionContent.propTypes = {
  name: PropTypes.string.isRequired,
  body: PropTypes.arrayOf(PropTypes.string).isRequired,
  color: PropTypes.string.isRequired,
};

const SelectOption = (props) => {
  const { data: { name, body, hex_color: color } } = props;

  return (
    <components.Option {...props}>
      <SelectOptionContent
        name={name}
        body={body}
        color={color}
      />
    </components.Option>
  );
};

SelectOption.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    body: PropTypes.arrayOf(PropTypes.string),
    hex_color: PropTypes.string,
  }).isRequired,
};

export default SelectOption;
